module.exports = __webpack_public_path__ + "static/media/tosta.062b0810.png";